// @ts-strict-ignore
import { useMemo, useState } from 'react'

import { useProduct } from '@/screens/Product/hooks/useProduct'

import { FullScreenModal } from '@/shared/ui/full-screen-modal'

import { DetailedSlider } from './components/detailed-slider/detailed-slider'
import { ThumbsGallery } from './components/thumbs-gallery/ThumbsGallery'
import { getProductSliderMedia } from './media'

export type ProductSliderProps = Record<string, never>

export const ProductSlider = (): JSX.Element => {
	const { product } = useProduct()
	const media = useMemo(() => getProductSliderMedia(product.IMAGES, product.VIDEO), [product.IMAGES, product.VIDEO])

	const [isFullScreenModalOpen, setIsFullScreenModalOpen] = useState(false)
	const [activeSlide, setActiveSlide] = useState<number>()

	const openFullScreenModal = () => setIsFullScreenModalOpen(true)
	const closeFullScreenModal = () => setIsFullScreenModalOpen(false)
	const handleSetActiveSlide = (index: number) => {
		setActiveSlide(index)
	}

	return (
		<>
			<ThumbsGallery
				title={product.TITLE}
				media={media}
				onClick={openFullScreenModal}
				setActiveSlide={handleSetActiveSlide}
				sections={product.SECTIONS}
			/>

			<FullScreenModal open={isFullScreenModalOpen} onClose={closeFullScreenModal}>
				<DetailedSlider media={media} activeSlide={activeSlide} />
			</FullScreenModal>
		</>
	)
}
